import Vue from 'vue'
import VueRouter from 'vue-router'
import {VersionDevOps,getDevOpsSpaceTokenDataApi} from '@/server/tops/devOps'
import {getDevOpsSpaceAllUserListApi, getDevOpsSpaceMenuListListApi} from '@/server/tops/base'
import store from '@/store'
import current from "element-ui/packages/table/src/store/current";
Vue.use(VueRouter)
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => err);
};
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => err);
};

const routes = [
  {
    path: '/',
    name: 'Index',
    redirect:'/Home/index',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '@/views/login.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '@/views/HomeView.vue'),
    redirect: '/Home/index',
    children: [{
          path: 'index',
          name: 'Index',
          meta:{ title: '首页'},
          component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/index/index.vue')
        },
        {
          path: 'devOpsProjectSpace',
          name: 'devOpsProjectSpace',
          meta:{ title: '项目管理'},
          component: () => import(/* webpackChunkName: "home" */ '@/components/Layout/Main.vue'),
          redirect: '/Home/devOpsProjectSpace/project',
          children:[{
            path: 'project',
            name: 'Project',
            meta:{ title: '项目首页'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeProject.vue'),
          }]
        },
        {
          path: 'devOpsDemandSpace',
          name: 'devOpsDemandSpace',
          meta:{ title: '需求管理'},
          component: () => import(/* webpackChunkName: "home" */ '@/components/Layout/Main.vue'),
          redirect: '/Home/devOpsDemandSpace/demand',
          children:[{
            path: 'demand',
            name: 'demand',
            meta:{ title: '需求首页'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeDemand.vue'),
          },
          {
            path: 'uat',
            name: 'UAT',
            meta:{ title: 'UAT'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeUat.vue')
          },
          {
            path: 'review',
            name: 'Review',
            meta:{ title: '技术评审'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeReview.vue')
          },
          {
            path: 'verify',
            name: 'Verify',
            meta:{ title: '线上验证'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeVerify.vue')
          }
        ]
        },
        {
          path: 'devOpsTaskSpace',
          name: 'devOpsTaskSpace',
          meta:{ title: '任务管理'},
          component: () => import(/* webpackChunkName: "home" */ '@/components/Layout/Main.vue'),
          redirect: '/Home/devOpsTaskSpace/allTask',
          children:[{
            path: 'devChecklist',
            name: 'devChecklist',
            meta:{ title: '任务池'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/devChecklist.vue'),
          },
          {
            path: 'allTask',
            name: 'allTask',
            meta:{ title: '任务清单'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeTask.vue'),
          },
          {
            path: 'devTask',
            name: 'devTask',
            meta:{ title: '开发任务'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeDevTask.vue')
          },
          {
            path: 'testTask',
            name: 'testTask',
            meta:{ title: '测试任务'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeTestTask.vue')
          },
          {
            path: 'otherTask',
            name: 'otherTask',
            meta:{ title: '其他任务'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeOtherTask.vue')
          },
          {
            path: 'bugTask',
            name: 'bugTask',
            meta:{ title: '缺陷管理'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/producerSpace/homeBugTask.vue')
          }
        ]
        },
        {
          path: 'devOpsReporterSpace',
          name: 'devOpsReporterSpace',
          meta:{ title: '报表空间'},
          component: () => import(/* webpackChunkName: "home" */ '@/components/Layout/Main.vue'),
          redirect: '/Home/devOpsReporterSpace/report',
          children:[{
            path: 'report',
            name: 'Report',
            meta:{ title: '人效报表'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace'),
          },
          {
            path: 'dailyReport',
            name: 'dailyReport',
            meta:{ title: '日报统计'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace/dailyReport.vue')
          },
          {
            path: 'projectReport',
            name: 'projectReport',
            meta:{ title: '项目报表'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace/projectReport.vue')
          },
            {
              path: 'weeklyReport',
              name: 'weeklyReport',
              meta:{ title: '人效周报'},
              component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace/weeklyReport.vue')
            },
              {
              path: 'kfr2site',
              name: 'kfr2site',
              meta:{ title: '客户对接数据分析'},
              component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace/kfr2site.vue')
            },
              {
              path: 'FD32',
              name: 'FD32',
              meta:{ title: '任务大屏'},
              component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace/FD32.vue')
            },
            {
              path: 'FD33',
              name: 'FD33',
              meta:{ title: 'AI大屏'},
              component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace/FD33.vue')
            },
              {
              path: 'gitlavReport',
              name: 'gitlavReport',
              meta:{ title: '代码行统计'},
              component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace/gitlavReport.vue')
            },
            {
              path: 'quarterReport',
              name: 'quarterReport',
              meta:{ title: '季度指标报表'},
              component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace/quarterReport.vue')
            },
            {
              path: 'aecResource',
              name: 'aecResource',
              meta:{ title: '技术资源统计表'},
              component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/reporterSpace/aecResource.vue')
            },
        ]
        },
        {
          path: 'devOpsSettingSpace',
          name: 'devOpsSettingSpace',
          meta:{ title: '配置中心'},
          component: () => import(/* webpackChunkName: "home" */ '@/components/Layout/Main.vue'),
          redirect: '/Home/devOpsSettingSpace/teamConfig',
          children:[{
            path: 'user',
            name: 'User',
            meta:{ title: '人员配置'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/settingSpace'),
          },
          {
            path: 'roleConfig',
            name: 'roleConfig',
            meta:{ title: '角色配置'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/settingSpace/roleConfig.vue')
          },
          {
            path: 'teamConfig',
            name: 'teamConfig',
            meta:{ title: '团队配置'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/settingSpace/teamConfig.vue')
          },
          {
            path: 'systemConfig',
            name: 'systemConfig',
            meta:{ title: '体系配置'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/settingSpace/systemConfig.vue')
          },
          {
            path: 'menuConfig',
            name: 'menuConfig',
            meta:{ title: '菜单配置'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/settingSpace/menuConfig.vue')
          },
            {
              path: 'dataConfig',
              name: 'dataConfig',
              meta:{ title: '数据字典'},
              component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/settingSpace/categoryConfig.vue')
            }
        ]
        },
        {
          path: 'devOpsOperatorSpace',
          name: 'devOpsOperatorSpace',
          meta:{ title: '运维空间'},
          component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/operationalSpace'),
        },
      {
        path: 'devOpsWorkOrder',
        name: 'devOpsWorkOrder',
        meta:{ title: '工单管理'},
        component: () => import(/* webpackChunkName: "home" */ '@/components/Layout/Main.vue'),
        redirect: '/Home/devOpsWorkOrder/workOrder',
        children:[{
          path: 'workOrder',
          name: 'workOrder',
          meta:{ title: '工单首页'},
          component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/workOrder/workOrder.vue'),
        },
          {
            path: 'my',
            name: 'My',
            meta:{ title: '我的工单'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/workOrder/myWorkOrder.vue'),
          },
          {
            path: 'deal',
            name: 'Deal',
            meta:{ title: '待认领工单'},
            component: () => import(/* webpackChunkName: "home" */ '@/views/tops/devOps/workOrder/dealtWorkOrder.vue'),
          }]
      },
      ]
  },

  //  #region tops路由部分 ---------start------------ */
  // 运维空间
  {
    path: '/devOpsOperatorSpace',
    name: 'devOpsOperatorSpace',
    meta: { title: 'devOpsOperationalSpace', },
    component: () => import(/* webpackChunkName: "about" */ '@/views/tops/devOps/operationalSpace')
  },
  // 报表空间
  {
    path: '/devOpsReporterSpace',
    name: 'devOpsReporterSpace',
    meta: { title: 'devOpsReporterSpace', },
    component: () => import(/* webpackChunkName: "about" */ '@/views/tops/devOps/reporterSpace')
  },
  // 系统设置空间
  {
    path: '/devOpsSettingSpace',
    name: 'devOpsSettingSpace',
    meta: { title: 'devOpsSettingSpace', },
    component: () => import('@/views/tops/devOps/settingSpace')
  },
  {
    path: '/devOpsAuthSpace',
    name: 'devOpsAuthSpace',
    component: () => import(/* webpackChunkName: "about" */ '@/views/auth.vue')
  },
  // 项目空间
  // {
  //   path: '/devOpsProjectSpace',
  //   name: 'devOpsProjectSpace',
  //   meta: { title: 'devOpsProjectSpace', },
  //   component: () => import('@/views/tops/devOps/producerSpace/homeProject.vue')
  // },
  // 需求空间
  {
    path: '/devOpsDemandSpace',
    name: 'devOpsDemandSpace',
    meta: { title: 'devOpsDemandSpace', },
    component: () => import('@/views/tops/devOps/producerSpace/homeDemand.vue')
  },
  // 任务空间
  {
    path: '/devOpsTaskSpace',
    name: 'devOpsTaskSpace',
    meta: { title: 'devOpsTaskSpace', },
    component: () => import('@/views/tops/devOps/producerSpace/homeTask.vue')
  },
  // 产品空间
  {
    path: '/devOpsProducerSpace',
    name: 'devOpsProducerSpace',
    meta: { title: 'devOpsProducerSpace', },
    component: () => import(/* webpackChunkName: "about" */ '@/views/tops/devOps/producerSpace')
  },
  // 产品空间
  {
    path: '/index',
    name: 'Index',
    meta: { title: 'index', },
    component: () => import(/* webpackChunkName: "about" */ '@/views/tops/devOps/index/index.vue')
  },
  {
    path: '/form',
    name: 'TopsForm',
    meta: { title: 'topsForm', },
    component: () => import(/* webpackChunkName: "about" */ '@/views/tops/form')
  },
  // #endregion tops路由部分 ---------end------------ */

  // #region  dms路由部分 ---------start------------ */
  {
    path: '/dms/messageWarning',
    name: 'MessageWarning',
    component: () => import('@/views/dms/messageWarning'),
  },
  {
    path: '/dms/healthScore',
    name: 'HealthScore',
    component: () => import('@/views/dms/healthScore'),
  },
  {
    path: '/dms/statisticalDetails',
    name: 'StatisticalDetails',
    component: () => import('@/views/dms/statisticalDetails'),
  },
  // #endregion dms路由部分 ---------end------------ */

  // #region  riskControl路由部分 ---------start------------ */
  {
    path: '/riskControl/reptile',
    name: 'Reptile',
    component: () => import('@/views/riskControl/reptile'),
  },
  // #endregion riskControl路由部分 ---------end------------ */


  // #region  distributionSystem路由部分 ---------start------------ */
  {
    path: '/distributionSystem/taskList',
    name: 'TaskList',
    component: () => import('@/views/distributionSystem/taskList'),
  },
  //  #endregion distributionSystem路由部分 ---------end------------ */

  {
    path: '*',
    name: 'notfound',
    component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFound.vue')
  }
]
const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  mode: 'history',
})
router.beforeEach(async (to, from, next) => {
  const params_query = new URLSearchParams(window.location.search);
  let accessToken = params_query.get('accessToken');
  let ssoFlag=params_query.get('ssoFlag')||'';
  console.log('ssoFlag',ssoFlag);
  if (accessToken) {
    await getDevOpsSpaceTokenDataApi({token: accessToken,ssoFlag:ssoFlag?Number(ssoFlag):''}).then(async (r) => {
      console.log('r',r);
        if (r.data.status === 'success') {
          if(ssoFlag){
            accessToken=r.data.data.token
          }
          store.state.devOps.token = accessToken;
          window.localStorage.setItem('token', accessToken);
          store.state.devOps.userInfo = r.data.data;
          window.localStorage.setItem('userInfo', JSON.stringify(r.data.data));
          const menudata = await getDevOpsSpaceMenuListListApi();
          if(menudata.status === 'success' && menudata.data.menulList.length > 0){
            //是否是当前当前路径-- 一级目录
            let is_path = 1;
            //要跳转的url
            let url = '';
            //要跳转的子级url
            let children_url = '';
            //当前子级的url
            let current_url = '';
            //是否有首页权限
            let is_show_index = 0;
            menudata.data.menulList.forEach((item,index)=>{
              console.log('item', item);
              item.children.forEach((item2)=>{
                if(item2.path && !to.path.includes(item2.path)){
                  // console.log(item2.path)
                  children_url = item2.path;
                }
              })

              if(to.path.includes(item.path)){
                is_path = 0;
              }
              if(to.path.includes(item.path) && item.children.length <1){
                current_url = item.path;
              }
              if(index === 0 && item.path){
                url = item.path;
              }
              if(item.path.includes('Home/index')){
                is_show_index = 1;
              }
              //console.log(index)
            })
            if(current_url){
              window.location.href = current_url;
              return
            }
            if(is_path){
              if(children_url) url = children_url;
              if(is_show_index) url = '/Home/index';
              window.location.href = url;
              return
            }
          }else{
            window.localStorage.setItem('token', null);
            window.location.href = '/login';
            return
          }
          // if (menudata.status === 'success') {
          //   window.location.href = '/Home/index';
          // }else{
          //   window.location.href = '/login';
          // }
        } else {
          window.location.href = '/login';
          return
        }
      });
    next();
 /*   await getDevOpsSpaceTokenDataApi({token: accessToken}).then(async (res) => {
      if (res.status === 'success') {
        store.state.devOps.token = accessToken;
        window.localStorage.setItem('token', accessToken);
        store.state.devOps.userInfo = res.data;
        window.localStorage.setItem('userInfo', JSON.stringify(res.data));
        let menudata = await getDevOpsSpaceMenuListListApi();
        if (menudata.status === 'success') {
          //store.state.devOps.menuList = menudata.data.menulList;
          //window.localStorage.setItem('menuList', JSON.stringify(menudata.data.menulList));
          window.location.href = '/Home/index';
         // next();
        }else{
          window.location.href = '/login';
        }

      } else {
        localStorage.removeItem('token');
        next({
          path: '/login'
        })
      }
    });*/
  } else {
    const token = window.localStorage.getItem("token");
    if(to.name !='Login' && from.name !='Login' && !store.state.devOps.NEWALLUSERLIST.ALLUSERIDLIST1 && token){
      if(from.path !='/'){
         window.location.href = to.path;
        // location.reload()
        return
      }
     }
    if(token && to.name !='Login'){
     await getDevOpsSpaceMenuListListApi().then((res)=>{
       if(res.status === 'success' && res.data.menulList.length > 0){
         //是否是当前当前路径-- 一级目录
         let is_path = 1;
         //要跳转的url
         let url = '';
         //要跳转的子级url
         let children_url = '';
         //当前子级的url
         let current_url = '';
         //是否有首页权限
         let is_show_index = 0;
           res.data.menulList.forEach((item,index)=>{
             item.children.forEach((item2)=>{
               if(item2.path && !to.path.includes(item2.path)){
                 if(!children_url){
                   children_url = item2.path;
                 }
               }
             })
             if(to.path.includes(item.path)){
               is_path = 0;
             }
             if(to.path.includes(item.path) && item.children.length <1){
               if(!current_url){
                 current_url = item.path;
               }
             }
             if(index === 0 && item.path){
               url = item.path;
             }
             if(item.path.includes('Home/index')){
               is_show_index = 1;
             }
             //console.log(index)
           })
         // if(current_url){
         //   window.location.href = current_url;
         //   return
         // }
         if(is_path&&!current_url){
           if(children_url) url = children_url;
           if(is_show_index) url = '/Home/index';
           window.location.href = url;
           return
         }

       }else{
         window.localStorage.setItem('token', null);
         window.location.href = '/login';
         return
       }
     });

    }
    next();
  }

  // const result = VersionDevOps()
  // if(result){
  //   next()
  // }
  //next();
})
export default router
